module.exports = __webpack_public_path__ + "static/img/heat-treatmentD.840cffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatmentD.png
// module id = CVsL
// module chunks = 1